import { DemandeApprobation } from "../types/models/demande-approbation";
import { HttpClient } from "./http-client";

export class ApprobationEntrepriseService {
  private readonly http: HttpClient;

  constructor(apiUrl: string) {
    this.http = new HttpClient(apiUrl);
  }

  async soumettreNouvelleDemande(idEntreprise: number): Promise<void> {
    await this.http.get(`/api/entreprises/${idEntreprise}`);
  }

  async getHistoriqueApprobation(
    idEntreprise: number,
  ): Promise<DemandeApprobation[]> {
    return this.http.get<DemandeApprobation[]>(
      `/api/entreprises/${idEntreprise}/demande-approbation`,
    );
  }
}
